export function fillNumberRangeArray(min: number, maxIncl: number, step: number = 1): number[] {
  return Array(Math.trunc((maxIncl - min) / step) + 1)
    .fill(0)
    .map((value, index) => min + index * step);
}
